/**
 * Whether react-router's bookkeeping places the current entry first in the history.
 *
 * react-router keeps its position in `history.state.idx`. A third-party `pushState`
 * that omits it is never repaired: RevenueCat's web checkout pushes `{ checkoutOpen: true }`
 * so that Browser Back closes it, and leaves that entry behind when the checkout is
 * closed or fails. react-router's next push computes `undefined + 1`, and every entry
 * for the rest of the session carries NaN. Only a literal 0 therefore means "nothing
 * behind us": an unreadable index is unknown, and callers fall through to
 * `navigate(-1)`, which the browser resolves from the real history.
 */
export const isHistoryStart = (): boolean =>
  (window.history.state as { idx?: unknown } | null)?.idx === 0;
